// Every notification gesture posts to one resource route: the banner renders in
// the shell layout rather than on the inbox route, so dismiss has to be
// reachable from any page in the app.
export const NOTIFICATION_MUTATION_PATH = '/resources/notifications';

// The newest N the popover shows per tab. The body is capped at 320px and a row
// is roughly 68px, so six overflows by about one row — which is the scroll
// affordance rather than an accident.
export const NOTIFICATION_POPOVER_LIMIT = 6;
